
import cInput from "@/components/FormElements/CustomInput.vue";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
  components: {
    cInput
  }
})
export default class KYC extends Vue {
  @Prop()
  private documentList!: any;
  @Prop()
  private tenantID!: any;

  private kyc: any = {
    idproofNo: "",
    addressproofNo: "",
    photo: "",
    idProof: "",
    addressProof: "",
    photouploaded: false,
    idProofuploaded: false,
    addressProofuploaded: false
  };
  private changePhoto(e) {
    const reader = new FileReader();
    reader.readAsDataURL(e.target.files[0]);
    reader.onload = () => {
      this.kyc.photo = reader.result;
      this.$emit("readKYC", this.kyc);
    };
    reader.onerror = err => {
      console.error("reader : ", err);
    };
  }

  private changeID(e) {
    const reader = new FileReader();
    reader.readAsDataURL(e.target.files[0]);
    reader.onload = () => {
      this.kyc.idProof = reader.result;
      this.$emit("readKYC", this.kyc);
    };
    reader.onerror = err => {
      console.error("reader : ", err);
    };
  }

  private changeAddress(e) {
    const reader = new FileReader();
    reader.readAsDataURL(e.target.files[0]);
    reader.onload = () => {
      this.kyc.addressProof = reader.result;
      this.$emit("readKYC", this.kyc);
    };
    reader.onerror = err => {
      console.error("reader : ", err);
    };
  }
  private UploadKyc(type) {
    let dataObj = {
      tenantId: this.$props.tenantID,
      document: {
        category: type,
        docType: "PHOTO",
        docuementNo:
          type === "ID_PROOF" ? this.kyc.idproofNo : this.kyc.addressproofNo,
        frontSideFile:
          type === "PHOTO"
            ? this.kyc.photo
            : type === "ID_PROOF"
            ? this.kyc.idProof
            : this.kyc.addressProof
      }
    };
    console.log(dataObj);
    this.$store
      .dispatch("tenant/submitKYCByTenant", dataObj)
      .then(result => {
        console.log(result);
        this.$swal({
          title: "Success",
          text: "Uploaded Successfully!",
          type: "success"
        });
        if (type === "PHOTO") {
          this.kyc.photo = "";
          this.kyc.photouploaded = true;
          this.$emit("readKYC", this.kyc);
        } else if (type === "ID_PROOF") {
          this.kyc.idProof = "";
          this.kyc.idProofuploaded = true;
          this.$emit("readKYC", this.kyc);
        } else {
          this.kyc.addressProof = "";
          this.kyc.addressProofuploaded = true;
          this.$emit("readKYC", this.kyc);
        }
      })
      .catch(error => {
        console.log(error);
      });
  }
}
